import React from 'react';
import VstComponent from './VstComponent';

export default class VstTabPanels extends VstComponent {

  render() {
    const { activeIndex, children } = this.props;
    return (
      <div role="tabpanel">{children[activeIndex]}</div>
    );
  }
}

VstTabPanels.defaultProps = {
  activeIndex: 0,
  children: []
};
